<template>
  <section id="banner" class="banner">
    <VueAgile :options="slideOptions" v-if="!loadingBanner " v-vpshow-scroll>
      <div class="agile-carousel">
        <div class="agile-carousel-caption">
          <div class="container">
            <h3 class="caption">{{ banner.heading }}</h3>
            <div class="text" v-html="banner.sub_heading"></div>
            <div
              class="cta-button mt-2"
              v-if="
                banner.button_url_mobile != null || banner.button_url_mobile != ''
              "
            >
              <a :href="banner.button_url_mobile" class="cta-link-btn">
                {{ banner.button_text }}
              </a>
            </div>

          </div>
        </div>
        <div class="bg-purple upper-background"></div>
        <img :src="banner.image_mobile_jpg" :alt="banner.heading" class="agile-carousel-image" />
      </div>
      <template slot="prevButton"><i class="fas fa-chevron-left"></i></template>
      <template slot="nextButton"><i class="fas fa-chevron-right"></i></template>
    </VueAgile>
    <PaxelLoader :loading="loadingBanner"></PaxelLoader>
  </section>
</template>

<script>
import { VueAgile } from 'vue-agile';
import i18n from '@/plugins/i18n';
import PaxelLoader from '@/components/PaxelLoader.vue';

export default {
  name: 'Banner',
  components: {
    VueAgile,
    PaxelLoader,
  },
  data() {
    return {
      banner: {},
      loadingBanner: true,
      slideOptions: {
        navButtons: false,
        autoplay: false,
        autoplaySpeed: 5000,
        speed: 2500,
        fade: true,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        timing: 'ease-in-out',
        changeDelay: 300,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              dots: false,
            },
          },
          {
            breakpoint: 900,
            settings: {
              navButtons: false,
              dots: false,
            },
          },
        ],
      },
    };
  },
  methods: {
    ctaURL(button) {
      const url = button.button_url_mobile
        ? `${this.$root.revampWebBaseURL}/${i18n.locale}/news-and-promos/detail/${button.created_at_date_only}/${button.id}`
        : button.button_url_mobile;
      return url;
    },
  },
  mounted() {
    this.$store.dispatch('fetchHomepageBanner', {
      language: this.$store.getters.getLanguage,
      limit: 1,
    });
  },
  created() {
    this.$store.watch(
      (state) => state.homepageBanner,
      (newValue) => {
        this.loadingBanner = true;
        this.banner = newValue;
        this.loadingBanner = false;
      },
    );
    this.$store.watch(
      (state) => state.language,
      (newValue) => {
        this.$store.dispatch('fetchHomepageBanner', {
          language: newValue,
          limit: 1,
        });
      },
    );
  },
};
</script>

<style>
.mobile-home .upper-background {
  height: 250px;
  margin-bottom: -1px;
  border-bottom: 5px solid #5e51a1;
}
.mobile-home .agile__nav-button {
  background: transparent;
  border: none;
  color: transparent;
  cursor: pointer;
  font-size: 24px;
  height: 100%;
  position: absolute;
  top: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  width: 80px;
}
.mobile-home .agile__nav-button:hover {
  /* background-color: rgba(0, 0, 0, 0.5); */
  color: #ffffff;
  opacity: 1;
}
.mobile-home .agile__nav-button--prev {
  left: 0;
}
.mobile-home .agile__nav-button--next {
  right: 0;
}
.mobile-home .agile__dots {
  bottom: 10px;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.mobile-home .agile__dot {
  margin: 0 10px;
}
.mobile-home .agile__dot button {
  background-color: transparent;
  border: 1px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  width: 10px;
}
.mobile-home .agile__dot--current button,
.mobile-home .agile__dot:hover button {
  background-color: #ffffff;
}
.mobile-home .agile-carousel-image {
  display: block;
  height: auto;
  -o-object-fit: cover;
  object-fit: contain;
  width: 100%;
}
.mobile-home .agile-carousel-caption {
  position: absolute;
  right: auto;
  top: 1%;
  width: 100%;
  left: auto;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 15px;
  text-align: left;
  color: #ffffff;
}
.mobile-home .agile-carousel-caption .caption {
  width: 262px;
  height: 30px;
  margin: 0 0 10px;
  font-family: "GothamBold";
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: 0.21px;
  color: #ffffff;
}
.mobile-home .agile-carousel-caption .text {
  height: 66px;
  margin: 40px 0 20px;
  font-family: "GothamBook";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: 0.2px;
  color: #ffffff;
}
</style>
<style scoped>
.mobile-home .cta-button {
  display: inline-flex;
}
.mobile-home .cta-button a {
  font-family: "GothamMedium";
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  border: none;
  padding: 12px;
  letter-spacing: normal;
  border-radius: 0.25rem;
  text-align: center;
  color: #424143;
  background-color: #ffffff;
  width: 134px;
}
.mobile-home .cta-button a.cta-link-btn:focus {
  border: none;
}
.mobile-home .cta-button a.cta-link-btn:hover {
  opacity: 0.9;
}
.mobile-home .download-button {
  display: flex;
  flex-direction: row;
}
.mobile-home a {
  flex: 0.25 1 auto;
}
.mobile-home .download-button img {
  border-radius: 8px;
}
</style>
